import { mapTwoWayState } from 'schepotin-vuex-helpers';

export default {
    computed: {
        ...mapTwoWayState({
            namespace: 'ad',
            prefix: true,
        }, [
            'ads',
        ]),
    },
};



// WEBPACK FOOTER //
// ./src/mixins/ad.js